import { Modal, Typography } from "antd";

export interface SharedLink {
  title: string;
  url: string;
  note: string;
}

interface Props {
  link: SharedLink | null;
  onClose(): void;
}

const LinkModal: React.FC<Props> = ({ link, onClose }) => (
  <Modal
    title={link?.title}
    open={link != null}
    onCancel={onClose}
    onOk={onClose}
    okText="Done"
    cancelButtonProps={{ style: { display: "none" } }}
  >
    <Typography.Paragraph copyable={{ text: link?.url }} code style={{ wordBreak: "break-all" }}>
      {link?.url}
    </Typography.Paragraph>
    <Typography.Paragraph type="secondary">{link?.note}</Typography.Paragraph>
  </Modal>
);

export default LinkModal;
